"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollDown = void 0;
exports.hasScrollDown = hasScrollDown;
var config_1 = require("../config");
var ScrollDown = /*#__PURE__*/function () {
  function ScrollDown() {
    _classCallCheck(this, ScrollDown);
    this.scrollDownButton = null;
    this.scrollDownTarget = null;
    this.scrollDownButton = document.querySelector(config_1.CONFIG.scrollDown.trigger);
    this.scrollDownTarget = document.querySelector(config_1.CONFIG.scrollDown.target);
    this.scrollDownButton.addEventListener('click', this.handleScrollDown.bind(this));
  }
  return _createClass(ScrollDown, [{
    key: "handleScrollDown",
    value: function handleScrollDown(event) {
      event.preventDefault();
      this.scrollDownTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }]);
}();
exports.ScrollDown = ScrollDown;
function hasScrollDown() {
  if (document.querySelector(config_1.CONFIG.scrollDown.trigger)) {
    return true;
  }
  return false;
}